import { render, staticRenderFns } from "./AiEvaluationCard.vue?vue&type=template&id=010692f7&scoped=true"
import script from "./AiEvaluationCard.vue?vue&type=script&lang=ts"
export * from "./AiEvaluationCard.vue?vue&type=script&lang=ts"
import style0 from "./AiEvaluationCard.vue?vue&type=style&index=0&id=010692f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010692f7",
  null
  
)

export default component.exports